import React from 'react'
import Container from 'react-bootstrap/Container'
import Image from 'react-bootstrap/Image'
import { Link } from 'react-router-dom'
import Logo from '../../assets/logo/logo.png'
import Phone from '../../assets/icons/header/phone.svg'
import Message from '../../assets/icons/header/message.svg'
import Location from '../../assets/icons/contact/location.svg'
import AboutService from '../../services/AboutService'
import './footer.css'

function Footer({ onLoad = () => {} }) {
  const [data, setData] = React.useState({})

  const { address, email_1, email_2, facebook_link, phone_number } = data || {}

  const getAboutPageData = React.useCallback(async () => {
    try {
      const response = await AboutService.getContactInfo()
      setData(response?.data || {})
      onLoad(response?.data || {})
    } catch (error) {
      console.log(error)
    }
  }, [onLoad])

  React.useEffect(() => {
    getAboutPageData()
  }, [getAboutPageData])

  const onClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className='ag-footer'>
      <Container>
        <div className='ag-footer__cta'>
          <div>
            <span>Actual Green Corporation</span>
            <h2>Healthy living, fair earning, trusted growth.</h2>
          </div>
          <Link className='ag-footer__cta-link' onClick={onClick} to='/contact'>
            Contact Us
          </Link>
        </div>

        <div className='ag-footer__grid'>
          <div className='ag-footer__brand'>
            <Link onClick={onClick} to='/'>
              <Image src={Logo} alt='Actual Green Corporation' />
            </Link>
            <p>
              Product-focused wellness and member growth under one recognizable
              Actual Green brand.
            </p>
          </div>

          <div className='ag-footer__column'>
            <h3>Explore</h3>
            <Link onClick={onClick} to='/'>Home</Link>
            <Link onClick={onClick} to='/products'>Products</Link>
            <Link onClick={onClick} to='/documents'>Documents</Link>
            <Link onClick={onClick} to='/about'>About Us</Link>
          </div>

          <div className='ag-footer__column'>
            <h3>Support</h3>
            <Link onClick={onClick} to='/contact'>Contact Us</Link>
            <Link onClick={onClick} to='/terms-of-uses'>Terms & Condition</Link>
            <Link onClick={onClick} to='/privacy'>Privacy & Policy</Link>
          </div>

          <div className='ag-footer__column ag-footer__contact'>
            <h3>Contact</h3>
            {address && (
              <div className='ag-footer__contact-item'>
                <Image src={Location} alt='' />
                <span>{address}</span>
              </div>
            )}
            {phone_number && (
              <a className='ag-footer__contact-item' href={`tel:${phone_number}`}>
                <Image src={Phone} alt='' />
                <span>{phone_number}</span>
              </a>
            )}
            {email_1 && (
              <a className='ag-footer__contact-item' href={`mailto:${email_1}`}>
                <Image src={Message} alt='' />
                <span>{email_1}</span>
              </a>
            )}
            {email_2 && (
              <a className='ag-footer__contact-item' href={`mailto:${email_2}`}>
                <Image src={Message} alt='' />
                <span>{email_2}</span>
              </a>
            )}
          </div>
        </div>

        <div className='ag-footer__bottom'>
          <span>© Actual Green Corporation</span>
          <div>
            <span>Change Theory - Gain Ownership</span>
            {facebook_link && (
              <a href={facebook_link} rel='noreferrer' target='_blank'>
                Facebook
              </a>
            )}
          </div>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
